import { render } from "./MyDialog.vue?vue&type=template&id=9b7aeb3a&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"

import "./MyDialog.vue?vue&type=style&index=0&id=9b7aeb3a&scoped=true&lang=css"

import exportComponent from "D:\\secret\\py\\main_bot\\bank-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7aeb3a"]])

export default __exports__